import {
  SET_LOADING_TRUE,
  SET_LOADING_FALSE,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILED,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILED,
  VERIFY_EMAIL_IN_PROGRESS,
  VERIFY_OTP_IN_PROGRESS,
  REFRESH_EXISTING_USER,
  LOG_USER_OUT,
} from "../../../constants/store";
import axiosInstance from "../../../config/https";

export const verifyEmailAddressAction = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: SET_LOADING_TRUE,
    });
    dispatch({
      type: VERIFY_EMAIL_IN_PROGRESS,
      payload: true,
    });
    const res = await axiosInstance.post(``, payload);
    if (res?.data) {
      dispatch({
        type: SET_LOADING_FALSE,
      });
      dispatch({
        type: VERIFY_EMAIL_SUCCESS,
        payload: res.data,
      });
    }
  } catch (e) {
    console.log("Response Error: ", e);
    dispatch({
      type: SET_LOADING_FALSE,
    });
    dispatch({
      type: VERIFY_EMAIL_FAILED,
      payload: false,
    });
  }
};

export const verifyOTPAction = (payload) => async (dispatch) => {
  dispatch({
    type: VERIFY_OTP_IN_PROGRESS,
    payload: true,
  });
  try {
    dispatch({
      type: SET_LOADING_TRUE,
    });
    const res = await axiosInstance.post(``, payload);
    if (res?.data) {
      dispatch({
        type: SET_LOADING_FALSE,
      });
      dispatch({
        type: VERIFY_OTP_SUCCESS,
        payload: res.data,
      });
    } else {
      dispatch({
        type: SET_LOADING_FALSE,
      });
      dispatch({
        type: VERIFY_OTP_FAILED,
        payload: true,
      });
    }
  } catch (e) {
    dispatch({
      type: SET_LOADING_FALSE,
    });
    dispatch({
      type: VERIFY_OTP_FAILED,
      payload: true,
    });
  }
};

export const refreshExistingUserAction = () => async (dispatch) => {
  dispatch({
    type: REFRESH_EXISTING_USER,
  });
};

export const logoutAction = () => async (dispatch) => {
  dispatch({
    type: LOG_USER_OUT,
  });
};
